import React, { useContext } from "react";
import { FcGoogle } from "react-icons/fc";
import Wosenderabout from "../../../../images/LandingPageImage/automated_replies_and_smart_flow_1x.webp";
import "../designcss/Wosenderaboutenable.css";
import { Link } from "react-router-dom";
import MyContext from "../../../../MyContext";

const Chatboxrepliespage = () => {
  const { openFreeTrialModal } = useContext(MyContext)
  return (
    <>
      <div className="about-hero-container">
        <div className="leftsidecontent">
          <span className="businessgrow">Automated Replies & Smart Flows</span>
          {/* <span className="usingwhatsapp">:</span> */}
          <span className="marketingservice">
            Streamlined WhatsApp Conversations
          </span>

          <p className="paracontent">
            In today’s fast-paced digital world, customers expect immediate
            responses and smooth, guided interactions. Delayed replies can
            result in lost leads and missed sales opportunities.
          </p>

          <div className="buttons">
             <Link to="/login" className="text-decoration-none">
            <button className="googlebtn">
              <FcGoogle /> Start With Google
            </button>
            </Link>
            <button onClick={openFreeTrialModal} className="demobtn">Book a Demo</button>
          </div>
        </div>

        <div className="rightsideimg">
          <img src={Wosenderabout} alt="" className="homescreen" />
        </div>
      </div>
    </>
  );
};

export default Chatboxrepliespage;
